export default __webpack_public_path__ + "static/media/michi.6b04c28d.jpg";